import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment.prod';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-contact-cabinet',
  templateUrl: './contact-cabinet.component.html',
  styleUrls: ['./contact-cabinet.component.scss']
})
export class ContactCabinetComponent implements OnInit {
  contactForm: FormGroup = new FormGroup({});
  formIsLoading: boolean = false;
  recapthaIsValidated: boolean = false;
  siteKey: string = '';


  constructor(private formBuilder: FormBuilder, private httpService: HttpService, private router: Router, private route: ActivatedRoute) { }
  ngOnInit(): void {
    this.initForm();
    this.siteKey = environment.recaptcha.siteKey;

    //if (environment.production == false) {
    this.recapthaIsValidated = true;

    //}
  }
  initForm() {
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      subject: ['', Validators.required],
      message: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);

    this.recapthaIsValidated = true;
  }

  onSubmitContactForm() {

    if (!this.recapthaIsValidated) {
      Swal.fire({
        icon: 'error',
        title: 'Oups',
        text: 'Veuillez confirmer que vous n\'êtes pas un robot.',
      })
    } else {
      let formValue: any = this.contactForm.value;

      this.formIsLoading = true;
      this.httpService.contact(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            this.formIsLoading = false;
            this.initForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Votre message a bien été envoyé.',
            })
          }
        },
        (error) => {
          this.formIsLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      );
    }
  }

}

